/**
 * Customer info form (CustomerInfoForm.tsx)
 */
export const CUSTOMER_INFO_FORM = {
  defaultError: 'Something went wrong. Please check the form and try again',
  signInSignUp: 'Sign in / Sign up',
  or: 'or',
  firstName: 'First Name*',
  lastName: 'Last Name*',
  accountEmail: 'Account Email Address',
  email: 'Email Address*',
  verifyEmail: 'Verify Email Address*',
  zipCode: 'Zip Code*',
  postalCode: 'Postal Code*',
  gifteeInfo: 'Giftee\'s Info',
  gifteeEmail: 'Email*',
  gifteeMessage: 'Message (optional)',
}

/**
 * Checkout step form (Checkout.tsx, AdditionalInfoField.tsx)
 */
export const CHECKOUT_FORM = {
  reviewTitle: 'Review Your Reservation',
  address: 'Address',
  city: 'City',
  state: 'State',
  selectState: 'Select a state',
  selectOne: 'Select One',
}

/**
 * Coupon code required modal (CouponModal.tsx)
 */
export const COUPON_MODAL = {
  header: 'Code required',
  goBack: 'Go Back',
  ticketsRemovedDisclaimer: '(tickets will be removed from your cart)',
}

/**
 * Messages built in checkout components, providers and utils
 */
export const CHECKOUT_MESSAGES = {
  giftRecipient: (email: string) => `Gift Recipient: ${email}`,
  ticketLine: (title: string, unitPrice: number, quantity: number) => `${title} ($${unitPrice} x ${quantity})`,
  startOver: 'To start your order over, click "Yes, Start Over". '
    + 'If you encounter problems, go to your email and click the link in your invitation email.',
  previewBlocked: 'If you experience issues checking out, start over by clicking the button in your invitation email. '
    + 'You may have added more tickets than you have available or waited too long. If error message continues, '
    + 'you may have exceeded your ticket limit.',
  codeRequiredFor: (modName: string) => `Code required for ${modName}`,
  perksExceeded: (remainingPerks: number | undefined) => (
    'You have exceeded the number of perks available for this membership. '
    + `You have ${remainingPerks} perks remaining.`
  ),
  saleTitle: (isEvents: boolean, orgName: string, cityName: string) => (
    `${isEvents ? 'Events' : 'Admission Tickets'} ${orgName} ${cityName}`
  ),
}
